<template>
  <v-card class="pb-2">
    <v-card-title class="flex-nowrap">
      <span class="video-cim capital-first-letter-only text-truncate">
        Bejelentkezés
      </span>
      <v-spacer></v-spacer>
      <v-btn icon @click="CloseModal">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" id="login" lazy-validation @submit.prevent="Login">
        <v-text-field
          class="mb-2"
          type="email"
          label="E-mail cím"
          v-model="form.email"
          :rules="validations.email"
          hide-details="auto"
        ></v-text-field>
        <v-text-field
          type="password"
          label="Jelszó"
          v-model="form.password"
          :rules="validations.password"
          hide-details="auto"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-btn
        color="success"
        type="submit"
        form="login"
        block
        :loading="loading"
      >
        {{ nyelvesites['belepes_text'] }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../functions/AppFunctions';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import { userService } from '../../services/UserService';
import { AppStoreTypes } from '../../store/modules/app';
import { useModal } from '../../utils/vue/modalHandler';
import { scrollToError, vEmail, vRequired } from '../../utils/vuetifyFormRules';

export default {
  name: 'login-modal',
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      loading: false,
    };
  },
  setup(props, context) {
    let { CloseModal, SetModalLoading, EmitEvent } = useModal(props, context);
    return { CloseModal, SetModalLoading, EmitEvent };
  },
  created() {},
  methods: {
    async Login() {
      if (!this.$refs.form.validate()) {
        console.log(this.form);
        scrollToError(this);
        return;
      }
      this.loading = true;
      try {
        await userService.Login({
          ...this.form,
          projektId: this.user.Projekt.Id,
        });
        this.CloseModal();
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    validations() {
      return {
        email: [vRequired(), vEmail()],
        password: [vRequired()],
      };
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
};
</script>
